"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylesSink = void 0;
const react_1 = require("react");
const React = require("react");
require("./styles.less");
class StylesSink extends react_1.Component {
    render() {
        return (React.createElement("div", null,
            React.createElement("h2", null, "Helper Classes"),
            React.createElement("div", { className: "helper" },
                React.createElement("h3", null, "Ellipisify"),
                React.createElement("div", { className: "ellipsify" }, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi mollis justo at auctor commodo."))));
    }
}
exports.StylesSink = StylesSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/styles/styles.tsx
// module id = 3677
// module chunks = 0